var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',_vm._b({ref:"modal",attrs:{"cancel-label":_vm.$t('global.close')},on:{"save":_vm.modalAction,"close":function($event){return _vm.$emit('close')}}},'Modal',_vm.modalProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }